import Vue from 'vue';
import axios from 'axios';

axios.defaults.headers.common['X-Requested-With'] = "XMLHttpRequest";

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found');
}

const search = new Vue({
    el: "#app",
    data: {
        allChecked: [],
        countries: [],
    },
    mounted: function () {
        if (countries !== ""){
            var _this = this;
            this.countries = countries;

            const set = new Set();
            const c = countries.filter(item => !set.has(item.group) ? set.add(item.group) : false);

            c.forEach(function (item) {
                _this.allChecked.push(item.group);
            });
        }
    },
    methods: {
        checked: function(k, row) {
            if (this.countries.find((item) => item.code === row.code) && this.allChecked.indexOf(k) < 0) {
                this.allChecked.push(k);
            } else {
                if (this.countries.filter((item) => item.group === row.group).length <= 0) {
                    this.allChecked = this.allChecked.filter((item) => item != k);
                }
            }
        },
        checkedAll: function(k, rows) {
            if (this.allChecked.indexOf(k) >= 0) {
                this.addAll(rows);
            } else {
                this.clearAll(rows);
            }
        },
        addAll: function (rows) {
            var _this = this;
            rows.forEach(function(item, index, array) {
                _this.countries.push({ code: item.code, title: item.title, group: item.group });
            });
        },
        clearAll: function(rows) {
            var _this = this;
            rows.forEach(function(item, index, array) {
                _this.remove(item);
            });
        },
        remove: function (row) {
            this.countries = this.countries.filter(function(item, index, array){
                return item.code != row.code;
            });

            if (this.countries.filter((item) => item.group === row.group).length <= 0) {
                this.allChecked = this.allChecked.filter((item) => item != row.group);
            }
        }
    }
});


// WEBPACK FOOTER //
// ./resources/assets/frontend/search.js